import { loginRequest } from "../authConfig";
import { msalInstance } from "./msalInstance";
import { generateInitialsImage } from "./utils/generateInitialsImage";

export async function getIdToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length !== 0) {
    const account = accounts[0];
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.idToken;
  }
}

export function login() {
  msalInstance
    .loginRedirect({ ...loginRequest, prompt: "create" })
    .catch((error) => console.log(error));
}

export async function getUserPhoto() {
  const accounts = msalInstance.getAllAccounts();
  const account = accounts[0];
  const response = await msalInstance.acquireTokenSilent({
    scores: ["User.Read"],
    account,
  });

  const res = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
    headers: {
      Authorization: `Bearer ${response.accessToken}`,
    },
  });

  let photo;

  if (res.ok) {
    const blob = await res.blob();
    photo = URL.createObjectURL(blob);
  } else {
    photo = generateInitialsImage(account.name);
  }

  return photo;
}
